import ValidationType from '../ValidationType';

class ContainsValueCaseSensitive extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    const errors = [];
    const compareValue = validation.value || '';
    const currentValue = fieldResponse.currentValue || '';

    // Attempt to find the compare value within the current value
    if (currentValue && !currentValue.includes(compareValue)) {
      const error = this.createValidationError({
        fieldResponse,
        key: 'ERROR_CONTAINS_VALUE_CASE_SENSITIVE',
        values: { value: compareValue },
        message: `Value should contain '${compareValue}' (case sensitive)`,
      });
      errors.push(error);
    }
    return errors;
  }
}

export default ContainsValueCaseSensitive;
